<template>
  <div class="page" :style="{ height: height }">
    <template v-if="$store.state.config.brand === 'yousee'">
      <div class="imageHome"></div>
      <v-btn class="more" text @click="more">了解更多</v-btn>
    </template>
    <template v-else>
      <div class="imageHomeZip"></div>
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: window.innerHeight + 'px'
    }
  },
  created () {},
  mounted () {},
  methods: {
    more () {
      window.open('https://youseeid.com')
    }
  }
}
</script>

<style scoped lang="scss">
.imageHome {
  width: 100%;
  height: 100%;
  background-position: bottom;
  background-image: url('~@/assets/images/youseeid.jpg');
  background-size: cover;
}
.imageHomeZip {
  top: 7vh;
  width: 100%;
  height: 100%;
  background-position: center;
  background-image: url('~@/assets/images/zipitbg.jpg');
  background-size: cover;
}
.more {
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  background-color: #c09f6a;
  text-align: center;
  line-height: 7vh !important;
  height: 7vh !important;
  font-size: 3.5vh;
  border-radius: 0;
}
</style>
